<ng-template [ngIf]="theme == 'wepal'">
  <jhi-navigation [isAuthenticated]="isAuthenticated()" [swaggerEnabled]="swaggerEnabled" [inProduction]="inProduction"></jhi-navigation>
  <main class="mx-0" [class.extended]="isHomePage()" [class.authenticated]="isAuthenticated()">
    <div class="container-fluid mt-3 mt-sm-0" [@simpleFadeAnimation]="prepareRoute(outlet)">
      <router-outlet #outlet="outlet"></router-outlet>
      <router-outlet name="popup"></router-outlet>
    </div>
  </main>
</ng-template>
<ng-template [ngIf]="theme == 'default'">
  <jhi-navigation [isAuthenticated]="isAuthenticated()" [swaggerEnabled]="swaggerEnabled" [inProduction]="inProduction"></jhi-navigation>
  <main class="mx-0" [class.authenticated]="isAuthenticated()">
    <div class="container-fluid" [@simpleFadeAnimation]="prepareRoute(outlet)">
      <router-outlet #outlet="outlet"></router-outlet>
      <router-outlet name="popup"></router-outlet>
    </div>
  </main>
</ng-template>

<jhi-bary-console></jhi-bary-console>
<div id="bary-cta-menu">
  <div class="dropdown-menu"></div>
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" [fullScreen]="true" [disableAnimation]="false" type="ball-scale-multiple"></ngx-spinner>
<ngx-spinner name="priceRefreshing" bdColor="rgba(0, 0, 0, 0.5)" size="default" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
  <p class="text-white">{{ 'SPINNER.SEARCH_OFFERS' | translate }}</p>
</ngx-spinner>
